import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=4b42c7fa&"
import script from "./TagSelector.vue?vue&type=script&lang=js&"
export * from "./TagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports